import { chakra, useMultiStyleConfig } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

import { Highlight, useFileContext } from '@frontend/legacy-components';

export type FileInlineCardLabelProps = HTMLChakraProps<'span'>;

export const FileInlineCardLabel = ({
  className,
  ...restProps
}: FileInlineCardLabelProps) => {
  const { filename, highlight, size } = useFileContext();
  const styles = useMultiStyleConfig('FileInlineCard', { size });

  const shouldHighlight = !!filename && !!highlight;

  return (
    <chakra.span
      className={cx('file-inline-card__label', className)}
      __css={styles.label}
      {...restProps}
    >
      {shouldHighlight ? (
        <Highlight query={highlight}>{filename}</Highlight>
      ) : (
        filename
      )}
    </chakra.span>
  );
};
